"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedLineItem = void 0;
var tslib_1 = require("tslib");
var change_case_1 = require("change-case");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var react_number_format_1 = (0, tslib_1.__importDefault)(require("react-number-format"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
var flexbox_1 = require("../flexbox");
var mini_icons_1 = require("../mini-icons");
var padding_1 = require("../padding");
var stack_1 = require("../stack");
var text_1 = require("../text");
var text_link_1 = require("../text-link");
var tooltip_1 = require("../tooltip");
function formatCurrency(amount) {
    return (react_1.default.createElement(react_number_format_1.default, { decimalScale: 2, displayType: "text", fixedDecimalScale: true, prefix: "$", thousandSeparator: true, value: amount }));
}
function Item(_a) {
    var value = _a.value, valueTextSize = _a.valueTextSize, valueType = _a.valueType, valueHref = _a.valueHref;
    if (valueHref) {
        return (react_1.default.createElement(text_link_1.TextLink, { variant: "secondary", href: valueHref },
            react_1.default.createElement(text_1.Text, { size: valueTextSize || 'extraLarge', weight: 300, color: "dark" }, valueType === 'currency' ? formatCurrency(value) : value)));
    }
    return (react_1.default.createElement(text_1.Text, { size: valueTextSize || 'extraLarge', weight: 300, color: "dark" }, valueType === 'currency' ? formatCurrency(value) : value));
}
function StackedLineItem(_a) {
    var label = _a.label, value = _a.value, _b = _a.valueType, valueType = _b === void 0 ? 'default' : _b, valueHref = _a.valueHref, valueTextSize = _a.valueTextSize, onUrlClick = _a.onUrlClick, items = _a.items, url = _a.url, urlText = _a.urlText, urlExternal = _a.urlExternal, testId = _a.testId, tooltip = _a.tooltip, _c = _a.gap, gap = _c === void 0 ? 2 : _c;
    var isEmpty = !value && !items && !url;
    var stackTestId = testId ? "".concat((0, change_case_1.paramCase)(label), "-").concat(testId) : (0, change_case_1.paramCase)(label);
    return (react_1.default.createElement(stack_1.Stack, { testId: stackTestId, direction: "vertical", gap: gap },
        react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
            react_1.default.createElement(text_1.Text, { size: "small" },
                react_1.default.createElement(StyledGray, null, label)),
            tooltip && (react_1.default.createElement(padding_1.Padding, { left: 4 },
                react_1.default.createElement(tooltip_1.Tooltip, { text: tooltip },
                    react_1.default.createElement(mini_icons_1.MiniIconQuestionMark, null))))),
        value && react_1.default.createElement(Item, { value: value, valueType: valueType, valueHref: valueHref, valueTextSize: valueTextSize }),
        items && (react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 2, key: items.length }, items
            .filter(function (el) { return !!el; })
            .map(function (node) {
            var isString = typeof node === 'string';
            if (isString) {
                return (react_1.default.createElement(text_1.Text, { key: node.toString(), weight: 300, color: "dark", prewrap: true }, node));
            }
            return react_1.default.createElement(react_1.default.Fragment, { key: node.toString() }, node);
        }))),
        url && (react_1.default.createElement(text_1.Text, { weight: 300 },
            react_1.default.createElement(text_link_1.TextLink, { target: urlExternal ? '_blank' : undefined, href: url, onClick: function (e) {
                    if (onUrlClick) {
                        e.preventDefault();
                        onUrlClick();
                    }
                } }, urlText || url))),
        isEmpty && (react_1.default.createElement(text_1.Text, { weight: 300 },
            react_1.default.createElement(StyledGray, { "data-testid": "empty" }, '\u2013')))));
}
exports.StackedLineItem = StackedLineItem;
var StyledGray = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors_1.colors.steel[400]);
var templateObject_1;
//# sourceMappingURL=index.js.map